import { IntelligenceModels } from '@models/intelligence.model';
import { crudActions, DatasetTableConfig, TableConfigBuilder, textColumn } from '@ui/lib/ui-kit/ui-dataset-table';

type EventTag = IntelligenceModels.EventTags.EventTag;

/**
 * Twin of the Database → Event tags table: the same two columns and the same
 * edit / delete row icons.
 *
 * Both icons act: the component binds `rowAction` and routes each id through
 * `IntelligenceModels.EventTags.RowActionId`. Editing reuses the create overlay
 * seeded with the hydrated document; deleting confirms first.
 */
export function createEventTagsResultTableConfig(): DatasetTableConfig<EventTag> {
  return new TableConfigBuilder<EventTag>()
    .columns([
      textColumn<EventTag>('name', 'CUSTOM_EVENTS.TABLE.NAME', {
        width: 'minmax(200px, 1fr)',
        mobileVisible: true,
      }),

      textColumn<EventTag>('_id', 'CUSTOM_EVENTS.TABLE.ID', {
        width: 'minmax(100px, 0.5fr)',
        mobileVisible: true,
        cardIcon: 'ui-icon-key',
      }),
    ])
    .actions(crudActions<EventTag>())
    .trackBy('_id')
    .build();
}
